import React, { FC } from 'react';
import SubFooter from './SubFooter/SubFooter';
import * as classes from './Footer.module.scss';
import cn from 'classnames';
import Container from '../../../../Common/Container/Container';
import SocialIcons from '../../../../Common/SocialIcons/SocialIcons';
import { Trans, useTranslation } from 'gatsby-plugin-react-i18next';
import { ANY_STRING } from '../../../../../constants/constants';
import Link from '../../../../Common/Link/Link';
import VolumeIcon from '../../../../../assets/icons/inline/volume.inline.svg';
import { ISocialNetwork } from '../../../../../interfaces/professional/Professional';

export interface FooterProps {
  sectorsList: string[];
  shortName: string;
  languages: string[];
  phoneNumber: string;
  addresses: string[];
  email: string;
  euVatNumber?: string;
  officialId?: string;
  socialLinks: ISocialNetwork[];
}

const Footer: FC<FooterProps> = ({
  shortName,
  languages,
  sectorsList,
  addresses,
  phoneNumber,
  socialLinks,
  email,
  euVatNumber,
  officialId,
}) => {
  const { t } = useTranslation();
  return (
    <footer className={classes.wrapper}>
      <Container>
        <div className='row'>
          <div className={cn('col-sm-4', classes.cellWrapper, classes.leftBlock, classes.topRowCell)}>
            <div className={classes.title}>{shortName}</div>
            <div className={classes.sectors}>{sectorsList.join(', ')}</div>
            <div>{euVatNumber}</div>
            <div>{officialId}</div>
          </div>
          <div className={cn('col-sm-4', classes.cellWrapper, classes.centeredBlock, classes.topRowCell)}>
            <div className={classes.title}>{t('footer.location')}</div>
            {addresses.map((item, index) => (
              <div key={index} className={classes.address}>
                {item}
              </div>
            ))}
          </div>
          <div className={cn('col-sm-4', classes.cellWrapper, classes.rightBlock, classes.topRowCell)}>
            <div className={classes.title}>{t('footer.contact')}</div>
            <div>
              <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
            </div>
            <div>
              <a href={`mailto:${email}`}>{email}</a>
            </div>
          </div>
        </div>
        <div className='row'>
          <div className={cn('col-sm-4', classes.cellWrapper, classes.leftBlock, classes.bottomRowCell)}>
            <div className={cn('d-sm-none', classes.title)}>{t('footer.languages')}</div>
            <span className={classes.volumeIcon}>
              <VolumeIcon />
            </span>
            {languages.join(', ')}
          </div>
          <div
            className={cn(
              'col-sm-4 d-sm-block d-none',
              classes.cellWrapper,
              classes.centeredBlock,
              classes.bottomRowCell,
              classes.preBlock,
            )}
          >
            <Trans i18nKey={'footer.webfolioDescription'}>
              {ANY_STRING}
              <Link isExternalLink isTargetBlank path={'footer.webfolioDescriptionLink'} className={classes.link}>
                {ANY_STRING}
              </Link>
              {ANY_STRING}
            </Trans>
          </div>
          <div className={cn('col-sm-4', classes.cellWrapper, classes.rightBlock, classes.bottomRowCell)}>
            {!!socialLinks.length && <SocialIcons items={socialLinks} />}
          </div>
        </div>
        <div className={cn('d-sm-none', classes.aboutWebfolio)}>
          <Trans i18nKey={'footer.webfolioDescription'}>
            {ANY_STRING}
            <Link isExternalLink isTargetBlank path={'footer.webfolioDescriptionLink'} className={classes.link}>
              {ANY_STRING}
            </Link>
            {ANY_STRING}
          </Trans>
        </div>
      </Container>
      <SubFooter shortName={shortName} />
    </footer>
  );
};

export default Footer;
